import {
  Divider, Accordion, Tooltip,
  Grid, Typography, Box, AccordionDetails, AccordionSummary, Button, IconButton, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Backdrop, Snackbar, CircularProgress
} from '@material-ui/core';
import React, { useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import { deepOrange } from '@mui/material/colors';
import { makeStyles } from '@material-ui/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import axios from 'src/utils/axios';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@material-ui/lab/Alert';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  title: {
    width: '100%',
    textAlign: 'center',
  },
  header: {
    fontWeight: 'bold',
    fontSize: '15px',
    width: '100%'
  },
  cards: {
    minHeight: 500
  },
  button: {
    marginLeft: theme.spacing(2),
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  activeCard: {
    backgroundColor: '	#bebebe', /* Aktif kart arka plan rengi */
    minHeight: 500
  },
  inactiveCard: {
    backgroundColor: '#ffffff', /* Pasif kart arka plan rengi */
    minHeight: 500
  },
  heading: {
    fontWeight: 'bold',
    fontSize: '0.9rem',
    color: '#FF8900'
  },
  brandHeaders: {
    textAlign: 'center',
    color: '#FF8900',
    marginTop: '1rem',
  }
}));


function SmsTextGuide() {
  const classes = useStyles();
  const [smsSablonKeys, setSmsSablonKeys] = React.useState([]);
  const [smsSablonLinks, setSmsSablonLinks] = React.useState([]);
  const [smsSablonLinksRequest, setSmsSablonLinksRequest] = React.useState([]);
  const [smsLinkPopUp, setSmsLinkPopUp] = React.useState(false);
  const [selectedItemId, setSelectedItemId] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [responseMessage, setresponseMessage] = React.useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  useEffect(() => {
    getSmsKeyKisaltmalar();
    getSmsSablonLinks();
  }, []);

  useEffect(() => {
    if (smsSablonLinks !== null) {
      setSmsSablonLinksRequest(smsSablonLinks);
    }
  }, [smsSablonLinks]);

  const getSmsKeyKisaltmalar = () => {
    axios.get("/GetSmsSablonKeyKisaltmalar").then((response) => {
      setSmsSablonKeys(response.data);
    })
  }

  const getSmsSablonLinks = () => {
    axios.get("/GetSmsSablonLinks").then((response) => {
      setSmsSablonLinks(response.data);
    })
  }

  const handleSMSLinkChange = (event, itemID) => {
    var Data = [...smsSablonLinksRequest];
    var index = Data.findIndex(x => x.ID === itemID);
    var Item = { ...Data[index], SMS_LINK: event.target.value };
    Data[index] = Item;
    setSmsSablonLinksRequest(Data);
  }

  function smsLinkGuncelle() {
    setLoading(true);
    var Data = [...smsSablonLinksRequest];
    var index = Data.findIndex(x => x.ID === selectedItemId);
    var Item = { ...Data[index] };
    const data = {
      Id: Item.ID,
      MarkaAdı: Item.MARKA_ADI,
      MarkaKodu: Item.MARKA_KODU,
      SablonKey: Item.SABLON_KEY,
      SmsLink: Item.SMS_LINK
    }

    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('/SetSmsSablonLinkGuncelleme', data, config).then(response => {
      setresponseMessage(response.data.ErrorDescription)
      setUyariTip("success");
      setUyari(true);
      setLoading(false);
      setSmsLinkPopUp(false);
    });
    setLoading(false);
  }

  const handleAvatarClick = (event, itemID) => {
    setSelectedItemId(itemID);
    setSmsLinkPopUp(true);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={uyari} autoHideDuration={2000} onClose={uyariKapat}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={uyariKapat} variant='filled' severity={uyariTip}>
          {responseMessage}
        </Alert>
      </Snackbar>
      <Grid>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className={classes.heading}>Sms Gönderim Kısayolları</Typography>
          </AccordionSummary>
          <Divider />
          <AccordionDetails>
            <Grid container spacing={1}>
              {smsSablonKeys?.map((item) => (
                <Grid item xs={12} sm={3} lg={3} key={item.ID} >
                  <Box sx={{ display: 'flex', alignItems: 'center' }} spacing={1}>
                    <Avatar
                      sx={{ bgcolor: deepOrange[500], width: 24, height: 24, fontSize: '10px' }}
                      alt="Remy Sharp"
                      src="/broken-image.jpg"
                      size="small"
                    >
                      {item.SABLON_KEY_KISALTMA}
                    </Avatar>
                    <Tooltip title={item.SABLON_KEY_ACIKLAMA}>
                      <Typography variant="h6" gutterBottom style={{ marginLeft: '0.6rem', marginTop: '0.5rem' }}>
                        {item.SABLON_KEY}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
      <Divider />
      <Grid>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className={classes.heading}>Sms Link Kısayolları ve Yönetimi</Typography>
          </AccordionSummary>
          <Divider />
          <AccordionDetails>
            <Grid>
              <Typography variant="h4" gutterBottom style={{ color: '#FF8900', margin: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                {'ARÇELİK'}
              </Typography>
              <Divider />
              <Grid container spacing={1}>
                {smsSablonLinksRequest?.filter((item) => item.MARKA_KODU === 3).map((item) => (
                  <Grid item xs={12} sm={6} lg={3} key={item.ID} >
                    <Box sx={{ display: 'flex', alignItems: 'center' }} spacing={1}>
                      <Avatar
                        sx={{ bgcolor: deepOrange[500], width: 24, height: 24, fontSize: '10px', cursor: 'pointer' }}
                        alt="Remy Sharp"
                        src="/broken-image.jpg"
                        size="small"
                        onClick={(event) => { handleAvatarClick(event, item.ID); }}
                      >
                        L
                      </Avatar>
                      <Typography variant="h6" gutterBottom style={{ marginLeft: '0.6rem', marginTop: '0.5rem' }}>
                        {item.SABLON_KEY + ' :'}
                      </Typography>
                      <Typography variant="body1" gutterBottom style={{ marginLeft: '0.6rem', marginTop: '0.5rem' }}>
                        {item.SMS_LINK}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
              <Divider />
              <Typography variant="h4" gutterBottom style={{ color: '#FF8900', margin: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                {'BEKO'}
              </Typography>
              <Divider />
              <Grid container spacing={1}>
                {smsSablonLinksRequest?.filter((item) => item.MARKA_KODU === 4).map((item) => (
                  <Grid item xs={12} sm={6} lg={3} key={item.ID} >
                    <Box sx={{ display: 'flex', alignItems: 'center' }} spacing={1}>
                      <Avatar
                        sx={{ bgcolor: deepOrange[500], width: 24, height: 24, fontSize: '10px', cursor: 'pointer' }}
                        alt="Remy Sharp"
                        src="/broken-image.jpg"
                        size="small"
                        onClick={(event) => { handleAvatarClick(event, item.ID); }}
                      >
                        L
                      </Avatar>
                      <Typography variant="h6" gutterBottom style={{ marginLeft: '0.6rem', marginTop: '0.5rem' }}>
                        {item.SABLON_KEY + ' :'}
                      </Typography>
                      <Typography variant="body1" gutterBottom style={{ marginLeft: '0.6rem', marginTop: '0.5rem' }}>
                        {item.SMS_LINK}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>

      {/* Link Güncelleme PopUp */}
      <Dialog
        open={smsLinkPopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          <Typography variant="h4" gutterBottom style={{ textAlign: 'center' }}>
            {'Link Güncelleme Sayfası'}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid>
            {smsSablonLinksRequest?.filter((item) => item.ID === selectedItemId).map((item) => (
              <Grid container spacing={2} key={item.ID}>
                <Grid item xs={12} sm={12} md={12}>
                  <Divider />
                  <Typography variant="h4" gutterBottom className={classes.brandHeaders}>
                    {'Marka Adı: ' + item.MARKA_ADI}
                  </Typography>
                  <Divider />

                </Grid>
                <Divider />
                <Grid item xs={4} md={4}>
                  <TextField
                    id="outlined-required"
                    size="medium"
                    disabled
                    fullWidth
                    variant="outlined"
                    placeholder='Lütfen Linki Giriniz.'
                    inputProps={{
                      style: {
                        fontWeight: 'bold',
                        opacity: 1,
                        color: 'black',
                      }
                    }}
                    value={item.SABLON_KEY}
                  />
                </Grid>
                <Grid item xs={8} md={8}>
                  <TextField
                    id="outlined-required"
                    size="medium"
                    fullWidth
                    variant="outlined"
                    placeholder='Lütfen Linki Giriniz.'
                    value={item.SMS_LINK}
                    onChange={(event) => handleSMSLinkChange(event, item.ID)}
                  />
                </Grid>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="medium"
            color='primary'
            style={{ color: '#FF9800', backgroundColor: '#424242', marginLeft: '1rem' }}
            onClick={() => { smsLinkGuncelle() }}
          >
            Güncelle
          </Button>
          <IconButton
            color="primary"
            aria-label="close"
            component="span"
            variant="contained"
            onClick={() => setSmsLinkPopUp(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog >
    </>
  );
}

export default SmsTextGuide;
